"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ImageNode = void 0;
const core_1 = require("@tiptap/core");
const utils_1 = require("./utils");
/**
 * @public
 */
exports.ImageNode = core_1.Node.create({
    name: 'image',
    addOptions() {
        return {
            inline: true,
            HTMLAttributes: {},
            getBlobRef: async () => ({ src: '', srcset: '' })
        };
    },
    inline() {
        return this.options.inline;
    },
    group() {
        return this.options.inline ? 'inline' : 'block';
    },
    draggable: true,
    selectable: true,
    addAttributes() {
        return {
            'file-id': {
                default: null
            },
            width: {
                default: null
            },
            height: {
                default: null
            },
            src: {
                default: null
            },
            alt: {
                default: null
            },
            title: {
                default: null
            },
            align: (0, utils_1.getDataAttribute)('align'),
            'data-file-type': {
                default: null
            }
        };
    },
    parseHTML() {
        return [
            {
                tag: `img[data-type="${this.name}"]`
            },
            {
                tag: 'img[src]'
            }
        ];
    },
    renderHTML({ node, HTMLAttributes }) {
        const divAttributes = {
            class: 'text-editor-image-container',
            'data-type': this.name,
            'data-align': node.attrs.align
        };
        const imgAttributes = (0, core_1.mergeAttributes)({
            'data-type': this.name
        }, this.options.HTMLAttributes, HTMLAttributes);
        const fileId = imgAttributes['file-id'];
        if (fileId != null) {
            imgAttributes.src = `platform://platform/files/workspace/?file=${fileId}`;
        }
        return ['div', divAttributes, ['img', imgAttributes]];
    }
});
//# sourceMappingURL=image.js.map